import { LayerGroup } from './LayerGroup.class';
Oskari.clazz.defineES('Oskari.mapframework.bundle.layerselector2.model.LayerGroup', LayerGroup);
